import { render, staticRenderFns } from "./LongxunRoom.vue?vue&type=template&id=bac87358&scoped=true&"
import script from "./LongxunRoom.vue?vue&type=script&lang=js&"
export * from "./LongxunRoom.vue?vue&type=script&lang=js&"
import style0 from "./LongxunRoom.vue?vue&type=style&index=0&id=bac87358&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac87358",
  null
  
)

export default component.exports